var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading||_vm.forceLoading)?_c('div',{class:("sole-loading-root font-sans " + _vm.rootClass + " h-screen w-screen fixed z-50 top-0")},[_c('spinner')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }